/* Utilizado para remover comportamento de Scroll em iframes.
* View utilizando componente: Resource Center
*/
document.addEventListener('DOMContentLoaded', () => {
  const iframe = document.querySelector('iframe.prevent-scroll')

  if (!iframe) return

  // Load iframe
  const loadIframe = () => {
    iframe.src = iframe.name
    const wrapper = iframe.parentElement

    iframe.onload = () => {
      wrapper.style.display = 'block'
    }
  }

  // Checa se ainda há requests pendentes.
  const checkState = () => {
    if (document.readyState === 'complete') {
      clearInterval(interval)
      loadIframe()
    }
  }

  const interval = setInterval(checkState, 100)
})
